import {
    DerivedComponent,
    FormComponentProps,
    FormType,
    KeyGridMeta,
} from "../../DynamicFormTypes.ts";
import React, {useEffect, useMemo} from "react";
import { useWatch} from "react-hook-form";
import {useFormMethods} from "../../DyanmicFormContext.tsx";
import {NumberField} from "../NumberField.tsx";
import {getStringValue, findKey} from "./derivedUtils.ts";
import {extractDataGridKey} from "../../dyanimcFormUtil.tsx";
import {useThrottled} from "../../hooks/useThrottled.ts";
import {isNull} from "lodash";
import {Spacer} from "../Spacer.tsx";

const SometimesNumberRenderer: React.FC<FormComponentProps<DerivedComponent>> = ({component}) => {
    const {formMethods} = useFormMethods();
    const {control, getValues} = formMethods;

    const watchKeys = useMemo(() => [
        ...new Set(component.listFieldKeys.filter(f => f.dataGrid).map(f => f.dataGrid!)),
        ...component.listFieldKeys.filter(f => !f.dataGrid).map(f => f.fieldKey),
    ], [component.listFieldKeys]);


    const trigger = useWatch({control, name: watchKeys});
    const throttledTrigger = useThrottled(trigger, 150);

    const conditionHasBeenMet = useMemo(() => {
        const fullKey = extractDataGridKey(component.fieldKey);
        const watchedValue = getStringValue(fullKey, findKey(KeyGridMeta.WATCHED_SELECT_FIELD, component), getValues);

        if (!watchedValue) {
            return false;
        }

        return component.forceValueWhen?.includes(watchedValue);
    }, [throttledTrigger]);

    useEffect(() => {
        if (conditionHasBeenMet) {
            formMethods.setValue(component.fieldKey, component.forcedValue, {shouldValidate:true});
        }
    }, [conditionHasBeenMet]);

    if (conditionHasBeenMet && isNull(component.forcedValue)) {
        return <Spacer component={{type: FormType.SPACER, size: 1, fieldKey: component.fieldKey, label: component.label, compactUI: component.compactUI}}/>
    }

    return <NumberField component={{type: FormType.NUMBER, fieldKey: component.fieldKey, label: component.label, compactUI: component.compactUI, validationRules: component.validationRules, suffix: component.suffix, defaultValue: component.defaultValue, formatNumberAs: component.formatNumberAs, fieldsToTriggerOnBlur: component.fieldsToTriggerOnBlur}} disabled={conditionHasBeenMet}/>;

};

export const SometimesNumber = React.memo(SometimesNumberRenderer);